import type { Theme, ThemeOptions } from '@mui/material/styles';

/** No color override — keeps MUI Rating's default star color. */
export function ratingThemeComponents(_theme: Theme): ThemeOptions['components'] {
  return {};
}
